import {
    IonButton, IonButtons,
    IonContent, IonFab, IonFabButton, IonHeader, IonIcon, IonInput,
    IonItem,
    IonItemDivider,
    IonLabel, IonList, IonModal,
    IonSearchbar, IonTitle, IonToggle, IonToolbar, useIonAlert,
    useIonToast,
    useIonViewWillEnter
} from "@ionic/react";
import AdminEntityList from "./AdminEntityList";
import React, {useRef, useState} from "react";
import {createUserName, getUser, updateUserName} from "../../repositories/adminUserRepository";
import {Access} from "../../entities/Access";
import moment from "moment/moment";
import PermissionRepositoryTypeIcon from "../PermissionRepositoryTypeIcon";
import {add} from "ionicons/icons";
import AdminServiceTypeTypeahead from "./AdminServiceTypeTypeahead";
import AdminUserNameTypeahead from "./AdminUserNameTypeahead";

export const AdminManageUserNames = ({user, userNames, setUserNames, reloadUserNames}) => {
    const [selectedUserName, setSelectedUserName] = useState(null);
    const [newUserName, setNewUserName] = useState({userId: user.id});
    const [presentToast, dismissToast] = useIonToast();
    const [presentAlert, dismissAlert] = useIonAlert();
    const modal = useRef();

    const openUserNameEditModal = (userName) => () => {
        setSelectedUserName(userName);
    }

    const saveUserName = async () => {
        try {
            const updatedUserName = await updateUserName();
            setUserNames(userNames.map(userName => userName.userName === updatedUserName.userName ? updatedUserName : userName));
            reloadUserNames();
            await presentToast({message: "Successfully saved username", duration: 2000, color: "success"});
            setSelectedUserName(null);
        } catch (e) {
            await presentToast({message: "Failed to save username", duration: 5000, color: "danger"});
        }
    }


    async function confirm() {
        const userName = await createUserName({
            userId: newUserName.userId,
            serviceTypeId: +newUserName.serviceType.serviceTypeId,
            userName: newUserName.userName.title
        });
        modal.current?.dismiss(newUserName, 'confirm');
    }

    function cancel() {
        presentAlert({
            header: 'Confirmation',
            message: 'Are you sure you want to discard the changes?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Confirm',
                    handler: () => {
                        modal.current?.dismiss()
                    }
                }
            ]
        })
    }

    async function handleSearch(ev) {
        // setUserNames(userNames.filter(userName => userName.userName.toLowerCase().includes(ev.target.value.toLowerCase())));
    }

    async function onCreateModalWillDismiss() {
        setNewUserName({userId: user.id})
    }

    return (
        <div>
            <IonItemDivider sticky className="usernames-list-search-bar">
                <IonButton className="ion-margin-start" fill="outline" slot="start" id="open-modal">
                    <IonIcon icon={add} />
                </IonButton>
                <IonSearchbar
                    debounce={1000}
                    mode="ios"
                    enterkeyhint="search" inputmode="search" onIonInput={(ev) => handleSearch(ev)}></IonSearchbar>
            </IonItemDivider>
            <IonList>
                {userNames?.map((userName, index) => (
                    <IonItem lines={index === userNames.length - 1 ? "none" : "inset"} key={index} button onClick={openUserNameEditModal(userName)}>
                        <PermissionRepositoryTypeIcon slot="start" type={userName.serviceType.permissionRepositoryType} />
                        <IonLabel>
                            <h3>{ userName.serviceType.serviceTypeName }</h3>
                            <p>{ userName.userName }</p>
                        </IonLabel>
                    </IonItem>
                ))}
            </IonList>

            <IonModal isOpen={selectedUserName !== null}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Edit username</IonTitle>
                        <IonButtons slot="start">
                            <IonButton onClick={() => setSelectedUserName(null)}>Cancel</IonButton>
                        </IonButtons>
                        <IonButtons slot="end">
                            <IonButton onClick={() => saveUserName(selectedUserName)}>Save</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <IonItem>
                        <IonInput></IonInput>
                    </IonItem>
                </IonContent>
            </IonModal>

            <IonModal ref={modal} trigger="open-modal" onWillDismiss={(ev) => onCreateModalWillDismiss(ev)}>
                <IonHeader>
                    <IonToolbar>
                        <IonButtons slot="start">
                            <IonButton onClick={() => cancel()}>Cancel</IonButton>
                        </IonButtons>
                        <IonTitle>Create username</IonTitle>
                        <IonButtons slot="end">
                            <IonButton
                                disabled={typeof newUserName.serviceType === "undefined" || typeof newUserName.userName === "undefined"}
                                strong={true}
                                onClick={() => confirm()}>
                                Confirm
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <AdminServiceTypeTypeahead
                        value={newUserName.serviceType}
                        setValue={(serviceType) => setNewUserName(x => ({...x, serviceType }))} />
                    <AdminUserNameTypeahead disabled={typeof newUserName.serviceType === "undefined"}
                                            serviceType={newUserName.serviceType}
                                            value={newUserName.userName}
                                            setValue={(userName) => setNewUserName(x => ({...x, userName}))}/>
                </IonContent>
            </IonModal>
        </div>
    );
}